import request from './../utils/request';

export function index(params) {
    return request({
      url: '/promotions',
      method: 'get',
      params
    })
}

export function inventory(params) {
  return request({
    url: '/promotions/inventory',
    method: 'get',
    params
  })
}

export function show(id) {
  return request({
    url: `/promotions/${id}`,
    method: 'get'
  })
}

export function store(data) {
  return request({
    url: '/promotions',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: `/promotions/${data.id}`,
    method: 'put',
    data
  })
}

export function destroy(id) {
  return request({
    url: `/promotions/${id}`,
    method: 'delete',
  })
}

